const context = window as any;

export const hasMobilePaymentApi = () => {
  return Boolean(
    context.startPayment &&
      context.startPayment.postMessage &&
      context.triggerRequestReview &&
      context.triggerRequestReview.postMessage
  );
};

export const startPayment = (orderId: string | null, paymentMethod: string | null) => {
  if (!orderId || !paymentMethod) {
    console.error(
      `Could not start mobile payment process. Arguments missing. orderId="${orderId}" paymentMethod="${paymentMethod}"`
    );
  }
  const payload = JSON.stringify({ orderId, paymentMethod });
  context.startPayment.postMessage(payload);
};

export const triggerRequestReview = () => {
  context.triggerRequestReview.postMessage('Triggering the Review Dialog');
};

export default {
  hasMobilePaymentApi,
  startPayment,
  triggerRequestReview,
};
